export { NewsletterProps } from "./newsletter.props";
export const name = "NewsletterComponent";
